export const LADE_AUSWAHLWERTE_ANMELDUNG = "ladeAuswahlwerteAnmeldung";
export const LADE_ABSCHLUESSE = "ladeAbschluesse";
